import styled from '@emotion/styled';
export const SectionContainer = styled.div`
  padding: 15px;
  margin-bottom: 15px;
`;
export const Title = styled.h2`

font-weight = 700px;
 margin-bottom: 15px;
 text-align: center;
`;
